import { logout } from '@/auth';
import { endCognitoSession } from '@/auth/utils/cognitoSession';

export default function LogoutPage() {
  return null;
}

export async function logoutPageLoader() {
  logout();
  // ENG-6102: let the Cognito sign-out finish before the reload, or the boot
  // could find its tokens still in storage. Resolves at once with the flag off.
  await endCognitoSession();

  // KT: note that we can't simply perform a router redirect here because we need the app to be
  // reloaded with a new viewer.
  window.location.assign('/login');
  return null;
}
